import type { CopilotProposalSummary } from "@repo/app-types/entities/copilotProposal";
import type { SignalProposalCardData } from "@repo/app-types/entities/signalProposal";
import type { CopilotProposalCardContent } from "../../researchAgent/copilotProposalCard.js";
import {
  buildSignalEditorPathname,
  buildSignalProposalEditLocation,
} from "./signalEditorUrlState.js";

/** What a signal proposal's card in the chat shows and opens. */
export function readSignalProposalCardContent(
  proposal: CopilotProposalSummary<"signal">,
): CopilotProposalCardContent {
  return {
    resourceType: "signal",
    operation: proposal.kind === "create_signal" ? "create" : "update",
    summary: describeSignalProposal(proposal.data),
    highlights: [],
    review: {
      kind: "open_editor",
      location: buildSignalProposalEditLocation({
        signalId:
          proposal.kind === "create_signal" ? undefined : proposal.resource.id,
        proposalId: proposal.id,
      }),
    },
    resourceLocation: {
      pathname: buildSignalEditorPathname(proposal.resource.id),
    },
  };
}

/** One sentence on what the signal would detect or what changes. */
function describeSignalProposal(data: SignalProposalCardData): string {
  switch (data.kind) {
    case "create_signal":
      return data.description;
    case "update_signal":
      return data.change_summary;
  }
}
